import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import Resources from '@/Resources.js';
import { notificationPreferences } from '@/Models';
import { useUserContextStore } from '@/Stores/Web/userContextStore.js';
import { enumToSelectOptions, mapEnumDisplayNameFromResource } from '@/Utils/EnumUtility';

/**
 * Select options for the communication preferences fields.
 * - basePreferenceOptions: email-only topics (no push).
 * - notificationPreferenceOptions: push-capable topics; push and the combined option are offered only when
 *   the user has push notifications enabled, otherwise it falls back to the base options.
 */
export function useNotificationPreferenceOptions() {
    const { hasPushNotificationsEnabled } = storeToRefs(useUserContextStore());
    const translatedPreferences = mapEnumDisplayNameFromResource(Resources.SubscriptionManagement, notificationPreferences);

    const basePreferenceOptions = computed(() =>
        enumToSelectOptions(translatedPreferences, e => e.value !== notificationPreferences.push));

    const notificationPreferenceOptions = computed(() => {
        if (hasPushNotificationsEnabled.value) {
            return enumToSelectOptions(translatedPreferences, undefined, undefined, true, [notificationPreferences.noNotifications]);
        }

        return basePreferenceOptions.value;
    });

    return {
        basePreferenceOptions,
        notificationPreferenceOptions,
    };
}
